"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preparePagefindItem = exports.isAlgoliaDomain = exports.interceptXMLHttpRequest = exports.extractIndexFromUrl = void 0;

var constants = _interopRequireWildcard(require("../constants"));

var _log = require("./log");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const isAlgoliaDomain = url => constants.algoliaDomains.some(domain => url.includes(domain));

exports.isAlgoliaDomain = isAlgoliaDomain;

const extractIndexFromUrl = url => {
  const regex = /indexes\/(.*?)\/query/;
  const match = url.match(regex);
  return match ? match[1] : null;
};

exports.extractIndexFromUrl = extractIndexFromUrl;

const preparePagefindItem = ({
  data,
  params,
  query
}) => {
  const itemHits = data.map(item => ({ ...JSON.parse(item.meta.custom),
    _highlightResult: {},
    _snippetResult: JSON.parse(item.content)
  }));
  return {
    hitsPerPage: constants.maxItemsNumber,
    nbHits: itemHits.length,
    hits: itemHits,
    nbPages: 1,
    page: 0,
    processingTimeMS: 1,
    renderingContent: {},
    serverTimeMS: 0,
    exhaustiveNbHits: true,
    exhaustiveTypo: true,
    exhaustive: {
      nbHits: true,
      typo: true
    },
    params,
    query
  };
};

exports.preparePagefindItem = preparePagefindItem;

const parseToAlgoliaResponse = async ({
  body,
  url
}) => {
  var _window2, _window2$pagefind;

  const algoliaIndexName = extractIndexFromUrl(url);

  if (!algoliaIndexName) {
    const results = await Promise.all(body.requests.map(async result => {
      var _window, _window$pagefind;

      const params = Object.fromEntries(new URLSearchParams(result.params));
      const query = (params === null || params === void 0 ? void 0 : params.query) || '';
      const search = await ((_window = window) === null || _window === void 0 ? void 0 : (_window$pagefind = _window.pagefind) === null || _window$pagefind === void 0 ? void 0 : _window$pagefind.search(query, {
        filters: {
          indexName: result.indexName
        }
      }));
      const data = search ? await Promise.all(search.results.slice(0, constants.maxItemsNumber).map(r => r.data())) : [];
      return preparePagefindItem({
        data,
        params,
        query
      });
    }));
    return {
      results
    };
  }

  const query = (body === null || body === void 0 ? void 0 : body.query) || '';
  const search = await ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$pagefind = _window2.pagefind) === null || _window2$pagefind === void 0 ? void 0 : _window2$pagefind.search(query, {
    filters: {
      indexName: algoliaIndexName
    }
  }));
  const data = search ? await Promise.all(search.results.slice(0, constants.maxItemsNumber).map(r => r.data())) : [];
  return preparePagefindItem({
    data,
    params: body,
    query
  });
};

const interceptXMLHttpRequest = () => {
  console.log((0, _log.fmt)('Static search interceptor initialized!'));
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (_method, url) {
    this.url = url; // eslint-disable-next-line prefer-rest-params

    originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = async function (body) {
    if (isAlgoliaDomain(this.url)) {
      const onResponseReadyStateChange = async () => {
        while (!((_window3 = window) !== null && _window3 !== void 0 && _window3.pagefind)) {
          var _window3;

          // eslint-disable-next-line no-promise-executor-return, no-await-in-loop
          await new Promise(resolve => setTimeout(resolve, 100));
        }

        try {
          const newResponse = JSON.stringify(await parseToAlgoliaResponse({
            body: body ? JSON.parse(body) : undefined,
            url: this.url
          }));
          Object.defineProperty(this, 'status', {
            value: 200,
            writable: true
          });
          Object.defineProperty(this, 'statusText', {
            value: 'OK',
            writable: true
          });
          Object.defineProperty(this, 'responseText', {
            value: newResponse,
            writable: true
          });
          this.dispatchEvent(new ProgressEvent('load'));
        } catch (error) {
          console.error('Error while modifying response:', error);
        }
      };

      await onResponseReadyStateChange();
      return;
    } // eslint-disable-next-line prefer-rest-params


    originalSend.apply(this, arguments);
  };
};

exports.interceptXMLHttpRequest = interceptXMLHttpRequest;